import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon, TrendingUpIcon, UsersIcon, GlobeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FranchisePage() {
  return <div className="min-h-screen bg-white" data-id="element-271">
      {/* Header */}
      <div className="bg-gray-900 text-white py-20 md:py-32" data-id="element-272">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-273">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-8 transition-colors" data-id="element-274">
            <ArrowLeftIcon size={16} data-id="element-275" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-7xl font-light mb-6" data-id="element-276">
            Franchise Opportunity
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl" data-id="element-277">
            Join the premium water revolution. Build a profitable business with
            WELLHAUS™.
          </p>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative h-[400px] md:h-[600px]" data-id="element-278">
        <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1600&q=80" alt="Business partnership" className="w-full h-full object-cover" data-id="element-279" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-280" />
      </div>

      {/* Why Franchise Section */}
      <div className="py-20 md:py-32 bg-white" data-id="element-281">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-282">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-283">
            <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-284">
              Why WELLHAUS™?
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-285">
              The premium water market is growing rapidly. Businesses and
              consumers are moving away from plastic bottles toward sustainable,
              on-demand solutions. This is your opportunity to lead that
              transformation.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-286">
            <div className="text-center space-y-4" data-id="element-287">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-water-blue" data-id="element-288">
                <TrendingUpIcon size={28} className="text-water-accent" data-id="element-289" />
              </div>
              <h3 className="text-2xl font-light" data-id="element-290">Growing Market</h3>
              <p className="text-gray-600" data-id="element-291">
                Premium water market projected to reach $24B by 2027.
                Sustainability trends driving demand for bottle-free solutions.
              </p>
            </div>

            <div className="text-center space-y-4" data-id="element-292">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-water-blue" data-id="element-293">
                <UsersIcon size={28} className="text-water-accent" data-id="element-294" />
              </div>
              <h3 className="text-2xl font-light" data-id="element-295">Proven Model</h3>
              <p className="text-gray-600" data-id="element-296">
                Established sales process, marketing materials, and support
                systems. We've done the hard work—you execute locally.
              </p>
            </div>

            <div className="text-center space-y-4" data-id="element-297">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-water-blue" data-id="element-298">
                <GlobeIcon size={28} className="text-water-accent" data-id="element-299" />
              </div>
              <h3 className="text-2xl font-light" data-id="element-300">Exclusive Territory</h3>
              <p className="text-gray-600" data-id="element-301">
                Protected territories ensure you're not competing with other
                franchisees. Build your business with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Business Model Section */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-302">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-303">
          <div className="max-w-4xl mx-auto space-y-20" data-id="element-304">
            {/* Revenue Streams */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-305">
              <div data-id="element-306">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-307">
                  Multiple Revenue Streams
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-308">
                  Build a sustainable business with recurring revenue from
                  equipment sales, installation, maintenance contracts, and
                  consumables.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-309">
                  <li className="flex items-start gap-3" data-id="element-310">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-311" />
                    <span data-id="element-312">
                      <strong data-id="element-313">Equipment Sales:</strong> Premium margins on Da
                      Vinci™ systems
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-314">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-315" />
                    <span data-id="element-316">
                      <strong data-id="element-317">Installation Services:</strong> Professional setup
                      and training
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-318">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-319" />
                    <span data-id="element-320">
                      <strong data-id="element-321">Maintenance Contracts:</strong> Recurring monthly
                      revenue
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-322">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-323" />
                    <span data-id="element-324">
                      <strong data-id="element-325">Filter & Consumables:</strong> Ongoing product
                      sales
                    </span>
                  </li>
                </ul>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-326">
                <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" alt="Business growth analytics" className="w-full h-full object-cover" data-id="element-327" />
              </div>
            </div>

            {/* Target Markets */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-328">
              <div className="order-2 md:order-1 relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-329">
                <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80" alt="Business meeting" className="w-full h-full object-cover" data-id="element-330" />
              </div>
              <div className="order-1 md:order-2" data-id="element-331">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-332">
                  Diverse Target Markets
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-333">
                  Sell to multiple high-value sectors. Each market segment
                  offers unique opportunities and strong margins.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-334">
                  <li className="flex items-start gap-3" data-id="element-335">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-336" />
                    <span data-id="element-337">Restaurants & Hotels (premium hospitality)</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-338">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-339" />
                    <span data-id="element-340">Luxury Condominiums (amenity upgrades)</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-341">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-342" />
                    <span data-id="element-343">Spas & Wellness Centers (health-focused)</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-344">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-345" />
                    <span data-id="element-346">Corporate Offices (employee benefits)</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-347">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-348" />
                    <span data-id="element-349">Specialty Retail (client experience)</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Support & Training */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-350">
              <div data-id="element-351">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-352">
                  Comprehensive Support
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-353">
                  We set you up for success from day one. Extensive training,
                  marketing support, and ongoing guidance to help you build a
                  thriving business.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-354">
                  <li className="flex items-start gap-3" data-id="element-355">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-356" />
                    <span data-id="element-357">
                      <strong data-id="element-358">Initial Training:</strong> Product knowledge,
                      sales, installation
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-359">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-360" />
                    <span data-id="element-361">
                      <strong data-id="element-362">Marketing Materials:</strong> Brochures,
                      presentations, digital assets
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-363">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-364" />
                    <span data-id="element-365">
                      <strong data-id="element-366">Lead Generation:</strong> National marketing
                      drives local leads
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-367">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-368" />
                    <span data-id="element-369">
                      <strong data-id="element-370">Ongoing Support:</strong> Technical, sales, and
                      business guidance
                    </span>
                  </li>
                </ul>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-371">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80" alt="Team training" className="w-full h-full object-cover" data-id="element-372" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Investment Section */}
      <div className="py-20 md:py-32 bg-white" data-id="element-373">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-374">
          <div className="max-w-4xl mx-auto" data-id="element-375">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-376">
              Investment Overview
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-377">
              <div className="bg-gray-50 p-8 rounded-2xl" data-id="element-378">
                <h3 className="text-2xl font-light mb-4" data-id="element-379">Initial Investment</h3>
                <div className="space-y-3 text-gray-700" data-id="element-380">
                  <div className="flex justify-between" data-id="element-381">
                    <span data-id="element-382">Franchise Fee</span>
                    <span className="font-medium" data-id="element-383">$50,000</span>
                  </div>
                  <div className="flex justify-between" data-id="element-384">
                    <span data-id="element-385">Initial Inventory</span>
                    <span className="font-medium" data-id="element-386">$75,000 - $100,000</span>
                  </div>
                  <div className="flex justify-between" data-id="element-387">
                    <span data-id="element-388">Marketing & Setup</span>
                    <span className="font-medium" data-id="element-389">$25,000 - $35,000</span>
                  </div>
                  <div className="border-t border-gray-300 pt-3 mt-3 flex justify-between font-medium text-lg" data-id="element-390">
                    <span data-id="element-391">Total Investment</span>
                    <span data-id="element-392">$150,000 - $185,000</span>
                  </div>
                </div>
              </div>

              <div className="bg-water-blue p-8 rounded-2xl" data-id="element-393">
                <h3 className="text-2xl font-light mb-4" data-id="element-394">Projected Returns</h3>
                <div className="space-y-3 text-gray-700" data-id="element-395">
                  <div className="flex justify-between" data-id="element-396">
                    <span data-id="element-397">Average Unit Sale</span>
                    <span className="font-medium" data-id="element-398">$8,000 - $12,000</span>
                  </div>
                  <div className="flex justify-between" data-id="element-399">
                    <span data-id="element-400">Monthly Recurring Revenue</span>
                    <span className="font-medium" data-id="element-401">$200 - $400/unit</span>
                  </div>
                  <div className="flex justify-between" data-id="element-402">
                    <span data-id="element-403">Target: Year 1 Sales</span>
                    <span className="font-medium" data-id="element-404">50-75 units</span>
                  </div>
                  <div className="border-t border-gray-300 pt-3 mt-3 flex justify-between font-medium text-lg" data-id="element-405">
                    <span data-id="element-406">Projected Year 1 Revenue</span>
                    <span data-id="element-407">$400,000 - $900,000</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 text-white p-8 md:p-12 rounded-2xl text-center" data-id="element-408">
              <p className="text-lg md:text-xl mb-2" data-id="element-409">
                <strong data-id="element-410">ROI Timeline:</strong> Most franchisees achieve
                profitability within 12-18 months
              </p>
              <p className="text-gray-300" data-id="element-411">
                Based on average performance across existing franchise
                territories
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Ideal Candidate Section */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-412">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-413">
          <div className="max-w-4xl mx-auto" data-id="element-414">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-415">
              Ideal Franchise Partner
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-416">
              <div className="space-y-4" data-id="element-417">
                <h3 className="text-2xl font-light mb-4" data-id="element-418">We're Looking For:</h3>
                <ul className="space-y-3 text-gray-700" data-id="element-419">
                  <li className="flex items-start gap-3" data-id="element-420">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-421" />
                    <span data-id="element-422">Sales or business development experience</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-423">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-424" />
                    <span data-id="element-425">Strong local business network</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-426">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-427" />
                    <span data-id="element-428">Entrepreneurial mindset and drive</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-429">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-430" />
                    <span data-id="element-431">Commitment to customer service excellence</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-432">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-433" />
                    <span data-id="element-434">Passion for sustainability and premium products</span>
                  </li>
                </ul>
              </div>

              <div className="space-y-4" data-id="element-435">
                <h3 className="text-2xl font-light mb-4" data-id="element-436">What You'll Do:</h3>
                <ul className="space-y-3 text-gray-700" data-id="element-437">
                  <li className="flex items-start gap-3" data-id="element-438">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-439" />
                    <span data-id="element-440">Build relationships with local businesses</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-441">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-442" />
                    <span data-id="element-443">
                      Conduct product demonstrations and consultations
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-444">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-445" />
                    <span data-id="element-446">
                      Coordinate installations with certified technicians
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-447">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-448" />
                    <span data-id="element-449">
                      Manage maintenance contracts and customer relationships
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-450">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-451" />
                    <span data-id="element-452">
                      Grow your territory and build a sustainable business
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Next Steps Section */}
      <div className="py-20 md:py-32 bg-white" data-id="element-453">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-454">
          <div className="max-w-4xl mx-auto text-center" data-id="element-455">
            <h2 className="text-4xl md:text-6xl font-light mb-8" data-id="element-456">Next Steps</h2>
            <p className="text-xl text-gray-600 mb-12 leading-relaxed" data-id="element-457">
              Ready to explore this opportunity? Here's how the process works:
            </p>

            <div className="grid md:grid-cols-4 gap-8 mb-16" data-id="element-458">
              <div className="text-center" data-id="element-459">
                <div className="w-12 h-12 rounded-full bg-water-accent text-white flex items-center justify-center text-xl font-medium mx-auto mb-4" data-id="element-460">
                  1
                </div>
                <h3 className="font-medium mb-2" data-id="element-461">Initial Inquiry</h3>
                <p className="text-sm text-gray-600" data-id="element-462">
                  Submit your information and we'll schedule an introductory
                  call
                </p>
              </div>

              <div className="text-center" data-id="element-463">
                <div className="w-12 h-12 rounded-full bg-water-accent text-white flex items-center justify-center text-xl font-medium mx-auto mb-4" data-id="element-464">
                  2
                </div>
                <h3 className="font-medium mb-2" data-id="element-465">Discovery</h3>
                <p className="text-sm text-gray-600" data-id="element-466">
                  Learn about the business model, review financials, and ask
                  questions
                </p>
              </div>

              <div className="text-center" data-id="element-467">
                <div className="w-12 h-12 rounded-full bg-water-accent text-white flex items-center justify-center text-xl font-medium mx-auto mb-4" data-id="element-468">
                  3
                </div>
                <h3 className="font-medium mb-2" data-id="element-469">Validation</h3>
                <p className="text-sm text-gray-600" data-id="element-470">
                  Speak with existing franchisees and visit our headquarters
                </p>
              </div>

              <div className="text-center" data-id="element-471">
                <div className="w-12 h-12 rounded-full bg-water-accent text-white flex items-center justify-center text-xl font-medium mx-auto mb-4" data-id="element-472">
                  4
                </div>
                <h3 className="font-medium mb-2" data-id="element-473">Launch</h3>
                <p className="text-sm text-gray-600" data-id="element-474">
                  Sign agreement, complete training, and launch your territory
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gray-900 text-white py-20 md:py-32" data-id="element-475">
        <div className="container mx-auto px-4 md:px-6 lg:px-12 text-center" data-id="element-476">
          <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-477">
            Start Your Journey Today
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-478">
            Join the WELLHAUS™ franchise network and build a profitable
            business in the growing premium water market.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-479">
            <a href="#franchise-inquiry" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors" data-id="element-480">
              Request Franchise Information
            </a>
            <a href="#schedule-call" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors" data-id="element-481">
              Schedule a Call
            </a>
          </div>
          <p className="text-sm text-gray-400 mt-8" data-id="element-482">
            Limited territories available. Contact us today to secure your area.
          </p>
        </div>
      </div>
    </div>;
}